import { render, staticRenderFns } from "./FeedbackQuestions.vue?vue&type=template&id=ed05e0f6"
import script from "./FeedbackQuestions.vue?vue&type=script&lang=ts"
export * from "./FeedbackQuestions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports